import _ from 'lodash';
import {Component, Module} from 'app/decorators';
import ProductStore from 'app/stores/product';
import tpl from './delivery.picker.html';


const pl5_customer = [
    'apply_haul_itemized',
    'haul_itemized',
];


@Module({
    name: "app.directives.customerDelivery.picker",
    modules: [
    ]
})
@Component({
    selector: 'blnd-customer-delivery-picker',
    bindings: {
        ngModel: '=',
        mode: '@?',
        priceLevel: '<?',
    },
    template: tpl,
})
export default class C {
    constructor ($scope, $element, Config) {
        "ngInject";
        this.scope = $scope;
        this.$element = $element;
        this.config = Config;
        this.mode = this.mode || 'view';

        // Initial values
        this.delivery = this.getDeliveryOptions(this.priceLevel);
        this.deliveryMap = _.fromPairs(this.delivery);
    }

    getDeliveryOptions (priceLevel) {
        if (_.isUndefined(priceLevel)) {
            return  this.config.$config.delivery;
        }
        let is5PL = priceLevel && priceLevel === 5;

        return _.filter(this.config.$config.delivery, function (obj) {
            let exists = pl5_customer.indexOf(obj[0]);
            return obj[0] == 'pickup' || is5PL && exists >= 0 || !is5PL && exists === -1;
        });
    }

    getName () {
        let self = this;
        return self.deliveryMap[self.ngModel];
    }

    $onChanges (changes) {
        if (this.mode === 'view') {
            return;
        }
        let isFirstChange = changes.priceLevel && changes.priceLevel.isFirstChange && changes.priceLevel.isFirstChange();
        if (isFirstChange || !changes.priceLevel) {
            return;
        }

        let currentValue = _.toInteger(changes.priceLevel.currentValue);
        let previousValue = _.toInteger(changes.priceLevel.previousValue);
        if (currentValue != previousValue) {
            this.ngModel = null;
            this.delivery = this.getDeliveryOptions(currentValue);
            this.deliveryMap = _.fromPairs(this.delivery);
        }
    }

    $onDestroy () {
        this.$element.remove();
        this.$element = null;
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/blnd.customer.delivery.picker.js